<template>
    <div class="module-assessments-chart mb-2">
        <div class="progress_bar_graph_outer_wrapper">
            <div class="progress_bar_graph_wrapper scrolling shadowright">
                <div class="progress_bar_graph">
                    <module-assessment-progess-bar 
                        v-for="assessment in assessments" 
                        :key="assessment.id"
                        :assessments="[assessment]"
                        :module="module.module"
                        :survey-cutoffs="surveyCutoffs[module.module.id]"
                    >
                        <span slot="title">{{assessment.finalized_at}}</span>
                    </module-assessment-progess-bar>
                    
                    <div class="progress_bar_graph_grid left"></div>
                    <div class="progress_bar_graph_grid right"></div>                  
                </div>
                <div class="progress_bar_graph_labels">
                    <div class="x_label">Room For Improvement</div>
                    <div class="x_label">Making Progress</div>
                    <div class="x_label text-primary"><strong>Leading the Way!</strong></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ModuleAssessmentProgessBar from './ModuleAssessmentProgressBar'
    
    export default {
        components: {
            ModuleAssessmentProgessBar
        },
        props: {
            assessments: {
                required: true,
                type: Array
            },
            module: {
                required: true,
                type: Object
            },
            surveyCutoffs: {
                required: true,
                type: Object
            }
        },
        data() {
            return {}
        },
        methods: {}
    
}
</script>